"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStore = createStore;

var _redux = require("redux");

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _root = _interopRequireDefault(require("MeetingsLib/redux/reducers/root"));

var _RavenContextMiddleware = _interopRequireDefault(require("MeetingsLib/redux/middleware/RavenContextMiddleware"));

var _TrackingMiddleware = _interopRequireDefault(require("MeetingsLib/redux/middleware/TrackingMiddleware"));

function createStore(initialState, httpClient) {
  var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
  var createStoreWithMiddleware = composeEnhancers((0, _redux.applyMiddleware)(_reduxThunk.default.withExtraArgument(httpClient), _TrackingMiddleware.default, _RavenContextMiddleware.default))(_redux.createStore);
  return createStoreWithMiddleware(_root.default, initialState);
}